import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Define styles using makeStyles
const useStyles = makeStyles(() => ({
	skipLink: {
		position: 'absolute',
		top: '-40px', // Initially hidden off-screen
		left: '60%', // Center horizontally
		backgroundColor: '#007DBA',
		color: '#fff',
		padding: '10px',
		fontSize: '14px',
		textDecoration: 'none',
		zIndex: 1101, // Ensure it's above other content
		borderRadius: '4px', // Optional: style for rounded corners
		'&:focus': {
			top: '10px', // Position the link near the top of the screen when focused
		},
		'&:focus-visible': {
			outline: '2px solid #002855',
		},
	},
	focusedElement: {
		//outline: 'none', // Remove the default outline style
		border: '2px solid black', // Apply a black border around the focused element
		padding: '4px', // Optional: add padding around the element to better highlight it
	},
}));

interface SkipLinkProps {
	qSelector: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({ qSelector }) => {
	const classes = useStyles(); // Hook to get styles

	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault(); // Prevent the default anchor link behavior (no URL change)
		const firstFocusableElement = document.querySelector(qSelector) as HTMLElement;
		if (firstFocusableElement) {
			firstFocusableElement.focus(); // Set focus to the first focusable element
			// Remove the focusedElement class after a short delay to allow tabbing to work again
			setTimeout(() => {
				firstFocusableElement.classList.remove(classes.focusedElement);
			}, 500); //
		}
	};

	return (
		<a
			href="#"
			onClick={handleClick}
			className={classes.skipLink} // Apply styles from the useStyles hook
		>
			Skip to main content
		</a>
	);
};

export default SkipLink;
